import React from 'react';
import { useStore } from 'effector-react';
import { FeatureType, ImageType, TemplateId } from '@types';
import { $templateId } from '@stores/dataStores';
import Image from '../Image';

type FIType = FeatureType | '_group';
type FIGroup = Record<FIType, string>;
type FIMap = Partial<Record<TemplateId, FIGroup>>;

const defaultGroup: FIGroup = {
  [FeatureType.link]: '/imgs/link.1065191873cfff43c480c7210049db29.png',
  [FeatureType.mobile]: '/imgs/mobile.5195f3b48db48237641d09192bde1650.png',
  [FeatureType.map]: '/imgs/map.7f7dbb8343eedd3056bba2c4a1a28dd7.png',
  [FeatureType.media]: '/imgs/media.9614446efb3ef3cabea2478c0db012d7.png',
  [FeatureType.text]: '/imgs/text.5db20df17fa6d0277dfa898b529365f9.png',
  [FeatureType.article]: '/imgs/article.87a094b8f14971d59072352a93bb2620.png',
  [FeatureType.audio]: '/imgs/audio.e0a9983c25e11d01fc178242430689f4.png',
  [FeatureType.video]: '/imgs/video.d2e6f0d9c184dc50cd388fed3c637438.png',
  [FeatureType.seqFrame]:
    '/imgs/seq_frame.936bc52b66d9d71f4f1a736fe668ab4d.png',
  [FeatureType.scene]: '/imgs/scene.e2de3aaf3396622d4625a6e98db9b3e5.png',
  [FeatureType.noFunc]: '',
  _group: '/imgs/group.f4a33291e0e1e5642b7d7504e9a0844c.png',
  [FeatureType.event]: '/imgs/event.2d7a96b98bce00a956effbc48604e040.png',
  [FeatureType.miniProgram]: '/imgs/mp.8d8633b111e83cf43b47ec96d375c6e2.png',
  [FeatureType.doc]: '/imgs/pdf_2.5206c704c1ca3923849d05a3cb2294b0.png',
  [FeatureType.model3d]: '/imgs/m3d.d93b9dd7b8bdceb50ec9c50747c4d610.png',
  [FeatureType.prevScene]: '/imgs/prev.210693fd89fedc0a0783fbe79a7b1092.png',
  [FeatureType.nextScene]: '/imgs/next.39e3e6c1da5653bb8acb4c1b89fa23e5.png',
};

const iconMaps: FIMap = {
  [TemplateId.metaverseA]: {
    [FeatureType.link]: '/imgs/ma-link.ec03076f6108cb112490964f4899a44f.png',
    [FeatureType.mobile]:
      '/imgs/ma-mobile.2521dbc5f26c494d7b6e4741b0640c75.png',
    [FeatureType.map]: '/imgs/ma-map.975ee2b031f833cbfb072cc32e312ab6.png',
    [FeatureType.media]: '/imgs/ma-media.bc8b3629e740a6571305341e7c995e14.png',
    [FeatureType.text]: '/imgs/ma-text.1e152edd58e98b718593fa742e9ff037.png',
    [FeatureType.article]:
      '/imgs/ma-article.53d40b87fa49299c7b035b6f6a44d626.png',
    [FeatureType.audio]: '/imgs/ma-audio.4b2fc93b17592b7381bd55cab25b2458.png',
    [FeatureType.video]: '/imgs/ma-video.e1a8bdb373898a98187dda63e0924c27.png',
    [FeatureType.seqFrame]:
      '/imgs/ma-seq_frame.ea9200dbe2d8540887fe8f148c59875f.png',
    [FeatureType.scene]: '/imgs/ma-scene.822c40f07b1fab22d927cbcc40e3e210.png',
    [FeatureType.noFunc]: '',
    _group: '/imgs/ma-group.de160b8f9ab173381a62afb554d7c968.png',
    [FeatureType.event]: '/imgs/ma-event.75c9eb5f3b51d1dd076648514155c975.png',
    [FeatureType.miniProgram]:
      '/imgs/ma-mp.18751eaca31456aa7a1696435ac054a3.png',
    [FeatureType.doc]: '/imgs/pdf_meta.9217a84147a105eee334aef705b9ed7b.png',
    [FeatureType.model3d]: '/imgs/m3d_m.c3f34a07688d2426618966770ac339ea.png',
    [FeatureType.prevScene]: '/imgs/prev.3ff2ec4dcf1fa6e7a0445541ef510638.png',
    [FeatureType.nextScene]: '/imgs/next.d2840612b778f1d90a43b0d31a62031b.png',
  },
  [TemplateId.realEstateB]: {
    [FeatureType.link]: '/imgs/link.a9d46400577645adbac8f5df06212899.png',
    [FeatureType.mobile]: '/imgs/mobile.f4eea2e37d992425b5e69b3dd2180410.png',
    [FeatureType.map]: '/imgs/map.64728c8dae87c3c1a9b3ca5f708e2e44.png',
    [FeatureType.media]: '/imgs/media.8e0f26bfa753c06971660712ead015e5.png',
    [FeatureType.text]: '/imgs/text.baf6c7c78c5de0678e714f7c7a72612a.png',
    [FeatureType.article]: '/imgs/article.6c2b794ea3ebb1ecfccdd89cbfc3f1c8.png',
    [FeatureType.audio]: '/imgs/aduio.85e4aa09a096d4588c925baea12ad84e.png',
    [FeatureType.video]: '/imgs/video.721a1ef46910f1621f9ebeff476ee0d1.png',
    [FeatureType.seqFrame]:
      '/imgs/seqFrame.834b1aa2966484a4d1c86e3898e0b273.png',
    [FeatureType.scene]: '/imgs/scene.6f99f0df9fb710cff5b9a7efd15d9d17.png',
    [FeatureType.noFunc]: '',
    _group: '/imgs/group.e57ab36d0e79425684dbf86f126b258c.png',
    [FeatureType.event]: '/imgs/event.b885fd71eb464545e324f69af0f8e0d8.png',
    [FeatureType.miniProgram]: '/imgs/mp.3fbc2cd702ca2c9410155bf167836ad1.png',
    [FeatureType.doc]: '/imgs/pdf_fcb.7d406384e8dcd333835ea52d41bd9067.png',
    [FeatureType.model3d]: '/imgs/m3d_r.c91909a12b8611f8503f69cfdb7a99f6.png',
    [FeatureType.prevScene]: '/imgs/prev.1a36c3b3b6f2bc8571f3c2162ac1de94.png',
    [FeatureType.nextScene]: '/imgs/next.e3d5c65c50c407c25cefa5bd3ff9a35f.png',
  },
  [TemplateId.legacy]: {
    [FeatureType.link]: '/imgs/link.3e52a3441e9090c7c7a73994560ebbf7.png',
    [FeatureType.mobile]: '/imgs/tel.c0ba9a0292239c47381b4110ae6cf1f9.png',
    [FeatureType.map]: '/imgs/nav.e76a8c4e552a8849c27c37b18f994c87.png',
    [FeatureType.media]: '/imgs/media.8e0f26bfa753c06971660712ead015e5.png', //
    [FeatureType.text]: '/imgs/text.31ce14651255c52ad6588436b3707ad7.png',
    [FeatureType.article]: '/imgs/arctile.d0747991d0fd679015cfe41743e07ae3.png',
    [FeatureType.audio]: '/imgs/music.d7794d3593178921838855651b664f82.png',
    [FeatureType.video]: '/imgs/video.e7e372ba867d923a24a77025c40e8e62.png',
    [FeatureType.seqFrame]: '/imgs/3d.5e52336cf1744d6cdbe9e8c380ccaf61.png',
    [FeatureType.scene]: '/imgs/list.1405ce71491e460ad4e5b452de7bf56e.png',
    [FeatureType.noFunc]: '/imgs/act.f539ab8beba2d4f0a558413f41fb8101.png',
    _group: '/imgs/group.2ac3cc956d271fe2f85b32ef735894c2.png',
    [FeatureType.event]: '/imgs/cutom.c03679f49f5637118a29f6643c006a4d.png',
    [FeatureType.miniProgram]: '/imgs/mp.2ab7a26dc9d25cb0a82934bc331f8091.png',
    [FeatureType.doc]: '/imgs/pdf_1.63960f951fbba843b37e266d06518c37.png',
    [FeatureType.model3d]: '/imgs/m3d_1.9d4abb3fc0de318822e0a80f689bb9ac.png',
    [FeatureType.prevScene]: '/imgs/prev.6eebdeee2465e6501102cbb44e6fbe80.png',
    [FeatureType.nextScene]: '/imgs/next.409487de1b3eb7a778db90f8ac03f5b5.png',
  },
  [TemplateId.simple]: {
    [FeatureType.link]: '/imgs/link.f6ecfd407a8e8c6d8161346f8cf666c9.png',
    [FeatureType.mobile]: '/imgs/tel.76fd1086ae5cfbc3a08761584da57707.png',
    [FeatureType.map]: '/imgs/nav.a2684eac2820b2fb7a1f511bab8a7934.png',
    [FeatureType.media]: '/imgs/image.a680921c261f1a2a7a9eac1fd42611d4.png',
    [FeatureType.text]: '/imgs/txt.d003316b5a1d74c2e84f6cd3e9512505.png',
    [FeatureType.article]: '/imgs/article.9e939ee63bc823a3d0f2982d1d54b7d2.png',
    [FeatureType.audio]: '/imgs/music.53d3572cf5ae924f62522ccbd6600b12.png',
    [FeatureType.video]: '/imgs/video.bd84d065984314aaa96a401dc4114eea.png',
    [FeatureType.seqFrame]: '/imgs/3d.cd8ca96f5de4ac630f4293c8aa956246.png',
    [FeatureType.scene]: '/imgs/list.07783afd9139350ac463ec7a9c8e4d3d.png',
    [FeatureType.noFunc]: '/imgs/action.5cb1e197d6b6caab67040e4f694c2790.png',
    _group: '/imgs/group.134328dd3460fa7a38f924febd1eecaf.png',
    [FeatureType.event]: '/imgs/action.5cb1e197d6b6caab67040e4f694c2790.png',
    [FeatureType.miniProgram]: '/imgs/mp.7a415ed3ccc6a7677068aea399a17d47.png',
    [FeatureType.doc]: '/imgs/pdf_pure.b7e88ad635fa697ff33bc5694986a9f0.png',
    [FeatureType.model3d]: '/imgs/m3d_s.f756d7124dc79821359a96b1dc6a082d.png',
    [FeatureType.prevScene]: '/imgs/prev.95011328947cce65a36c0afd003ed5d6.png',
    [FeatureType.nextScene]: '/imgs/next.2164e7691ac6d80a322b344065db478a.png',
  },
};

interface Props {
  type: FIType;
  className: string;
}

function FeatureIcon({ type, className }: Props) {
  const templateId = useStore($templateId);
  const group = iconMaps[templateId] || defaultGroup;
  return (
    <Image
      className={className}
      alt=""
      src={group[type]}
      type={ImageType.sysMedia}
    />
  );
}

export default FeatureIcon;
